<template>
  <div class="bg">
    <div class="content">
      <div class="btn">
        <el-button type="info" @click="quitBtn" size="mini"> 取消 </el-button>
        <el-button type="primary" size="mini" @click="submitForm"> 提交 </el-button>
      </div>
      <el-form label-width="auto" label-position="left">
        <el-card>
          <el-row>
            <el-form-item label="姓名：">{{ detailForm.name }}</el-form-item>
            <el-form-item label="银行卡照片：">
              <el-upload
                class="avatar-uploader"
                action="#"
                :http-request="uploadPic"
                accept="image/*"
                capture="camera"
                :show-file-list="false"
                :on-change="handlePictureCardPreviewBank"
              >
                <el-image v-if="bankCard" :src="bankCard" fit="contain" class="avatar">
                </el-image>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

            <el-form-item label="银行卡号：">
              <el-input size="small" v-model="detailForm.payRollBankCardNumber">
              </el-input>
            </el-form-item>
            <el-form-item label="银行名称：">
              <el-input size="small" v-model="bkName" :disabled="true"> </el-input>
            </el-form-item>
          </el-row>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import { postFile } from "@/api/file";
import { compress } from "@/utils/file";
import { filtration$ } from "@/utils/admin";
import { postDetail, postSubmitForm } from "@/api/app/roster";
import { postIdentifyBankCard } from "@/api/publicServer/index";
import { postSelectBankNameByBankCode } from "@/api/publicServer/bank";
let bankCardSuccess = 0;
export default {
  data() {
    return {
      bankCard: "",
      bkName: "",
      detailForm: [],
    };
  },
  created() {
    this.$store.dispatch("submitToken");
    this.detail();
  },
  watch: {
    "detailForm.payRollBankCardNumber": function () {
      if (this.detailForm.payRollBankCardNumber) {
        if (this.detailForm.payRollBankCardNumber.length >= 6) {
          let banCode = this.detailForm.payRollBankCardNumber.substring(0, 6);
          postSelectBankNameByBankCode(banCode).then((res) => {
            this.detailForm.payRollBankName = this.bkName = res.data;
          });
        } else {
          this.detailForm.payRollBankName = this.bkName = "";
        }
      }
    },
  },
  methods: {
    //获取信息
    detail() {
      postDetail(this.$store.state.app.itemId).then((res) => {
        this.detailForm = res.data;
      });
    },
    uploadPic() {},
    handlePictureCardPreviewBank(file) {
      if (file.status == "ready") {
        let _that = this;
        let params = {};
        params.format = "jpeg";
        params.folderName = "card_bank";
        const isLt15M = file.size / 1024 / 1024 < 15;
        const isLt1M = file.size / 1021 / 1024 < 1;
        if (!isLt15M) {
         _that.$notify({ type: "error", message: "上传图片大小不能超过 15M！" });
          return false;
        } else if (isLt1M) {
          let reader = new FileReader();
          reader.readAsDataURL(file.raw);
          reader.onload = (e) => {
            if (e.currentTarget.result.search("png") !== -1) {
              params.format = "png";
              let base64 = e.currentTarget.result.replace("data:image/png;base64,", "");
              params.content = base64;
            }
            if (e.currentTarget.result.search("jpeg") !== -1) {
              params.format = "jpeg";
              let base64 = e.currentTarget.result.replace("data:image/jpeg;base64,", "");
              params.content = base64;
            }
            postFile(params).then((res) => {
              if (res.code == 200) {
                _that.$notify({ type: "success", message: "照片选择成功！" });
                // _that.bankCard = res.data.url;
                bankCardSuccess = 1;
                postIdentifyBankCard(JSON.stringify(res.data.path)).then((res) => {
                  if (res.data.result == null) {
                    _that.bkName = res.data.result.bank_name;
                    _that.detailForm.payRollBankName = res.data.result.bank_name;
                    let bank = res.data.result.bank_card_number.split(" ");
                    let bankCardNum = bank.join("");
                    _that.detailForm.payRollBankCardNumber = bankCardNum;
                    bankCardSuccess = 1;
                  } else {
                    _that.$notify({ type: "error", message: "请选择符合要求照片！" });
                    bankCardSuccess = 2;
                  }
                });
              } else {
                _that.$notify({ type: "error", message: "照片选择失败！请重新选择。" });
              }
            });
          };
        } else {
          this.bankCard = URL.createObjectURL(file.raw);
          compress(file.raw, function (val) {
            let newFile = new window.File([val], file.name, { type: file.raw.type });
            newFile.uid = file.uid;
            let reader = new FileReader();
            reader.readAsDataURL(newFile);
            reader.onload = (e) => {
              if (e.currentTarget.result.search("png") !== -1) {
                params.format = "png";
                let base64 = e.currentTarget.result.replace("data:image/png;base64,", "");
                params.content = base64;
              }
              if (e.currentTarget.result.search("jpeg") !== -1) {
                params.format = "jpeg";
                let base64 = e.currentTarget.result.replace(
                  "data:image/jpeg;base64,",
                  ""
                );
                params.content = base64;
              }
              postFile(params).then((res) => {
                if (res.code == 200) {
                  _that.$notify({ type: "success", message: "照片选择成功！正在识别银行卡信息。" });
                  // _that.bankCard = res.data.url;
                  postIdentifyBankCard(JSON.stringify(res.data.path)).then((res) => {
                    if (res.data.result !== null) {
                      _that.bkName = res.data.result.bank_name;
                      _that.detailForm.payRollBankName = res.data.result.bank_name;
                      let bank = res.data.result.bank_card_number.split(" ");
                      let bankCardNum = bank.join("");
                      _that.detailForm.payRollBankCardNumber = bankCardNum;
                      bankCardSuccess = 1;
                    } else {
                      _that.$notify({ type: "error", message: "请选择符合要求照片！" });
                      bankCardSuccess = 2;
                    }
                  });
                } else {
                  _that.$notify({ type: "error", message: "照片选择失败！请重新选择。" });
                }
              });
            };
          });
        }
      }
    },
    submitForm() {
      if (bankCardSuccess === 1) {
        delete this.detailForm.unitId;
        delete this.detailForm.collectionPhotos;
        postSubmitForm(filtration$(this.detailForm))
          .then((res) => {
            if (res.code == 200) {
              this.$notify({ type: "success", message: "提交成功！" });
              // 暂留
              this.$router.back();
            }
          })
          .catch((error) => {
            this.$store.dispatch("submitToken");
          });
      } else if (bankCardSuccess == 2) {
        this.$notify({ type: "warning", message: "请选择符合要求照片！" });
      } else if (bankCardSuccess == 0) {
        this.$notify({ type: "warning", message: "请耐心等待照片上传完毕！" });
      }
    },
    //取消按钮
    quitBtn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  padding: 10px;
  min-height: 100vh;
  background-color: #f0f0f0;
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.content {
  .btn {
    text-align: right;
    margin-bottom: 10px;
  }
  .el-form-item {
    margin: 0px;
    font-size: 14px;
  }
  p {
    i {
      font-size: 12px;
    }
  }
  /deep/ .el-input__inner {
    border: unset;
    padding: 0;
  }
}
</style>
